// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Menu: React.FC<{ width?: number; height?: number }> = ({ width = 22, height = 20 }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 22 20">
            <path
                fill="currentColor"
                d="M20.821 17.391H1.134C.53 17.391 0 17.978 0 18.647 0 19.413.53 20 1.134 20h19.687C21.47 20 22 19.413 22 18.745c0-.767-.53-1.354-1.179-1.354m0-17.391H1.134C.53 0 0 .587 0 1.255 0 1.924.53 2.61 1.134 2.61h19.687c.649 0 1.179-.587 1.179-1.256C22 .685 21.47 0 20.821 0m0 8.696H1.134C.53 8.696 0 9.283 0 10s.53 1.304 1.134 1.304h19.687C21.47 11.304 22 10.717 22 10s-.53-1.304-1.179-1.304"
            />
        </svg>
    );
};

export default React.memo(Menu);
